module.exports = __webpack_public_path__ + "img/call1.0e31b493.png";